import React, { type ComponentProps } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { StyleSheet, Text } from 'react-native';

import { Button, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuHeaderChangeLocationButton = (props: MenuHeaderChangeLocationButtonProps) => {
  const { style, ...buttonProps } = props;

  const { formatMessage } = useIntl();

  return (
    <Button
      palette="kaleLightest"
      size="small"
      accessibilityLabel={formatMessage(messages.label)}
      style={[styles.button, style]}
      {...buttonProps}
    >
      <Text style={styles.label}>
        <FormattedMessage {...messages.label} />
      </Text>
    </Button>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  label: {
    defaultMessage: 'Change location',
    description: 'Menu | Header | Change location button | Label',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  button: {
    paddingHorizontal: theme.spacing['4'],
  },
  label: {
    color: theme.colors.KALE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type MenuHeaderChangeLocationButtonProps = Omit<ComponentProps<typeof Button>, 'children'>;
